import { formatDate, getDateByTimeZone } from "@/lib/date";

export function getCsLookupRange(delivery) {
  const fromZoned =
    getDateByTimeZone(delivery?.receiptDate) ||
    getDateByTimeZone(delivery?.bookedAt) ||
    getDateByTimeZone();
  const createdAtFrom = formatDate(fromZoned) || formatDate(getDateByTimeZone());
  const createdAtTo = formatDate(getDateByTimeZone());

  return { createdAtFrom, createdAtTo };
}

export async function loadCsHistoryByDelivery({
  bookId,
  delivery,
  fetchByIdOnTheFly,
  fetchByBookId,
}) {
  const detail = delivery || (await fetchByIdOnTheFly(bookId));

  if (!detail?.bookId) {
    throw new Error("배송건을 찾을 수 없습니다.");
  }

  const range = getCsLookupRange(detail);
  const rows = await fetchByBookId(detail.bookId, range);

  return {
    delivery: detail,
    range,
    rows: rows || [],
  };
}
